import { useRouter } from 'next/router'

import { LoadingOverlay } from '@/components/ui'
import { ROUTE } from '@/const'
import { isDenebEnabled } from '@/const/flags'
import { useSession } from '@/hooks/features/auth'
import { useProxyStore } from '@/providers/proxyStore/ProxyStoreContext'

import { withLimitedMode } from '../WithLimitedMode'
import { WithAuthProps } from './type'

/**
 * ログインユーザーのみアクセスを許可
 * 非ログインユーザーがアクセスを試みた場合はログインページへリダイレクト
 * 社員モードで代理店舗未選択の場合は代理店舗選択ページへリダイレクト
 */
export const withAuth = (PageComponent: WithAuthProps) => {
  const AuthenticatedPage = (props: any) => {
    const router = useRouter()
    const { isAuthenticated, isLoading, isPasswordResetRequired } = useSession()
    const { storeCode } = useProxyStore()

    if (isAuthenticated) {
      if (isDenebEnabled && router.pathname !== ROUTE.selectStore) {
        if (!storeCode) {
          router.push(ROUTE.selectStore)
          return null
        }
      }

      return <PageComponent {...props} />
    }

    if (isLoading) {
      return <LoadingOverlay isLoading={true} />
    }

    if (isPasswordResetRequired) {
      router.push(ROUTE.resetPassword)
      return null
    }

    router.push(ROUTE.login)
    return null
  }

  return withLimitedMode(AuthenticatedPage)
}
